import React, { useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Sidebar from "./Sidebar"; // Assuming Sidebar component is imported
import LoggedInHeader from "./Header"; // Assuming Header component is imported
import LoggedInFooter from "./Footer"; // Assuming Footer component is imported
import { IconButton, Input, InputAdornment, useMediaQuery } from "@mui/material";
import SidebarMobile from "./SidebarMobile";
import CommonTextField from "../../components/common/CommonTextField";
import { Height, Search, Menu } from "@mui/icons-material";


// Styling for the main content
const MainContent = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "hidden",
    backgroundColor: "#FFF",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

  })
);

export default function LoggedInLayout({ children, searchBar = true }) {
  const theme = useTheme();

  const [open, setOpen] = useState(true);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // detect mobile
  const [globalSearch, setGlobalSearch] = useState("");
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Handle input change logic here
    setGlobalSearch(value);
  }
  const toggleSidebar = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: "flex" }} className='logged-in-layout'>
      <CssBaseline />
      {/* Header */}
      {/* <LoggedInHeader isOpen={open} isMobile={isMobile} toggleSidebar={toggleSidebar} /> */}
      {/* Sidebar */}
      {
        isMobile ? <SidebarMobile open={open} toggleSidebar={toggleSidebar} /> : <Sidebar open={open} toggleSidebar={toggleSidebar} />
      }

      {isMobile && !open && (
        <Box display={"flex"} sx={{ position: 'fixed', top: 0, left: 0, height: '64px', width: '100%', backgroundColor: 'RGB(41 46 92)', zIndex: 1300, alignItems: 'center', justifyContent: 'center' }}>

          <IconButton
            sx={{ position: 'fixed', top: 16, left: 16, zIndex: 1300, backgroundColor: 'RGB(41 46 92)', color: '#556773' }}
            edge="start"
            onClick={toggleSidebar}
          >
            <Menu />
          </IconButton>
          <img
            src="/assets/images/logo-white.png"
            alt="Company Logo"
            style={{ width: "150px", height: "28px", marginBottom: "17px" }}

          />
        </Box>
      )
      }

      {/* Main Content */}
      <MainContent open={open}   >

        <Box sx={{ minHeight: "100vh", mt: isMobile ? '74px' : '0px' }} >
          {searchBar && <Box sx={{
            mt: { xs: "20px", sm: "38px" },
            mb: "20px",
            ml: { xs: "12px", sm: "21px" },
            mr: { xs: "12px", sm: 0 },
            display: "flex",
          }}>
            <CommonTextField
              placeholder="Search"
              name="Search"
              type="Search"
              value={globalSearch}
              onChange={handleInputChange}
                    disabled={true}

              inputProps={{


                sx: { backgroundColor: "#F6AA48", padding: "10px 14px", border: "none", color: "#fff" },

              }}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment sx={{ backgroundColor: "RGB(41 46 92)" }} position="start">
                      {<Search />}
                    </InputAdornment>
                  )
                },
              }}
              sx={{
                width: { xs: "100%", sm: "95%" },
                minWidth: { xs: 0, sm: 400 },
                '& .MuiInputAdornment-root': {
                  maxHeight: '48px',
                  height: '48px',
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                  backgroundColor: 'RGB(41 46 92)',
                  color: '#fff',
                  width: "50px",
                  marginRight: 0,
                  display: 'flex',
                  justifyContent: 'center',

                },


                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F5F5F5',
                  height: '48px',
                  paddingRight: '0px',

                  '& fieldset': {
                    border: 'none', // 🔥 remove border
                  },
                  '&:hover fieldset': {
                    border: 'none',
                  },
                  '&.Mui-focused fieldset': {
                    border: 'none',

                  },
                },

                '& .MuiOutlinedInput-input': {
                  padding: '12px 14px',
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                },

              }}
            />
          </Box>}


          {children}
        </Box>
        {/* Footer */}
        {/* <LoggedInFooter /> */}
      </MainContent>

    </Box>
  );
}
